import { WIZARD_ERROR_MESSAGE } from "../../../../../wizard/constants";
import {
  validateAmountAndType,
  validateOtherFeesGroup,
} from "../../../validators/validators";
import { DurationUnit } from "../../../../../../types";
import { isPositiveNumber } from "../../../../../../helpers";
import { TValidator } from "../../../../../wizard/types";

type CommonObject = { [key: string]: any };

const validator: TValidator = async ({ values, activeStepName }) => {
  const errors: CommonObject = {};
  const notifyMessages: string[] = [];
  errors.mainOtherFees = [];
  errors.addedOtherFees = [];

  const stepValues = values[activeStepName] ?? {};

  if (!stepValues.tuition?.trim()) {
    errors.tuition = "Tuition is required";
  } else if (!isPositiveNumber(stepValues.tuition)) {
    errors.tuition = "Tuition is not valid";
  } else if (stepValues.tuition.trim().split(".")[1]?.length > 2) {
    errors.tuition = "Max 2 digits allowed after decimal point";
  }

  if (!stepValues.currency) {
    errors.currency = "Currency is required";
  }

  if (!stepValues.commissionAmount?.trim()) {
    errors.commissionAmount = "Commission is required";
  } else if (!isPositiveNumber(stepValues.commissionAmount)) {
    errors.commissionAmount = "Commission is not valid";
  } else if (
    stepValues?.commissionType?.name === "Percent" &&
    +stepValues.commissionAmount > 100
  ) {
    errors.commissionAmount = "Enter less than 100";
  } else if (stepValues.commissionAmount.trim().split(".")[1]?.length > 2) {
    errors.commissionAmount = "Max 2 digits allowed after decimal point";
  }

  if (!stepValues.commissionType) {
    errors.commissionType = "Type is required";
  }

  if (!stepValues.tuitionDurationUnit) {
    errors.tuitionDurationUnit = "Duration period is required";
  }

  if (stepValues?.tuitionDurationUnit?.id !== DurationUnit.FULL) {
    if (!stepValues.tuitionDurationAmount?.trim()) {
      errors.tuitionDurationAmount = "Duration is required";
    } else if (!isPositiveNumber(stepValues.tuitionDurationAmount)) {
      errors.tuitionDurationAmount = "Duration is not valid";
    } else if (stepValues.tuitionDurationAmount >= 10000) {
      errors.tuitionDurationAmount = "Max 4 digits allowed";
    } else if (
      stepValues.tuitionDurationAmount.trim().split(".")[1]?.length > 2
    ) {
      errors.tuitionDurationAmount = "Max 2 digits allowed after decimal point";
    }
  }

  // check other fee names duplications --------------------------------
  const allOtherFees = [
    ...(stepValues.mainOtherFees || []),
    ...(stepValues.addedOtherFees || []),
  ].filter((fee) => fee && (fee.name?.trim() || fee.amount?.trim()));

  const allOtherFeesNames = allOtherFees.reduce((names, fee) => {
    return fee?.name?.trim() ? [...names, fee.name.trim()] : names;
  }, []);

  if (new Set(allOtherFeesNames).size !== allOtherFeesNames.length) {
    const message = "There are other fees with the same name";
    errors.otherFees = message;
    notifyMessages.push(message);
  }

  // check if other fee has name, mark amount as required
  // check if other fee has amount , mark name as required
  validateOtherFeesGroup(stepValues.mainOtherFees, "mainOtherFees", errors);
  validateOtherFeesGroup(stepValues.addedOtherFees, "addedOtherFees", errors);

  // Calculation --------------------------------------------------

  validateAmountAndType(
    stepValues.tuitionScholarshipAmount,
    "tuitionScholarshipAmount",
    stepValues.tuitionScholarshipType,
    "tuitionScholarshipType",
    errors,
  );

  validateAmountAndType(
    stepValues.tuitionFinancialAidAmount,
    "tuitionFinancialAidAmount",
    stepValues.tuitionFinancialAidType,
    "tuitionFinancialAidType",
    errors,
  );

  validateAmountAndType(
    stepValues.otherFeesScholarshipAmount,
    "otherFeesScholarshipAmount",
    stepValues.otherFeesScholarshipType,
    "otherFeesScholarshipType",
    errors,
  );

  validateAmountAndType(
    stepValues.otherFeesFinancialAidAmount,
    "otherFeesFinancialAidAmount",
    stepValues.otherFeesFinancialAidType,
    "otherFeesFinancialAidType",
    errors,
  );

  if (
    errors.mainOtherFees.length > 0 ||
    errors.addedOtherFees.length > 0 ||
    Object.keys(errors).length - 2 > 0
  ) {
    throw {
      [WIZARD_ERROR_MESSAGE]: notifyMessages.join("\n\n"),
      [activeStepName]: errors,
    };
  }
};

export default validator;
